import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, finalize } from "rxjs/operators";
import { LoaderService } from "./loader.service";
import { AuthService } from '../auth/auth.service';


declare const NF: any;
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private _loading: LoaderService,
    public _authService: AuthService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.id_token;
    this._loading.setLoading(true, req.url);

    const request = token
      ? req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      })
      : req;

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status == 500) {
            let message: any = event.body.message == 'jwt expired' ? 'Sesión expirada' : 'Se produjo un error, intentelo nuevamente';
         
            NF.Notification.show({
              type: NF.Notification.Type.ERROR,
              title: "Error",
              content: message,
              position: NF.Notification.Positions.TOP_RIGHT,
              clickClose: true,
              autoHideDelay: 8000,
            });
          }
        }
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status == 401) {
          let message: any = err.error.message == 'jwt expired' ? 'Sesión expirada' : 'Se produjo un error, intentelo nuevamente';
         
          NF.Notification.show({
            type: NF.Notification.Type.ERROR,
            title: "Error",
            content: message,
            position: NF.Notification.Positions.TOP_RIGHT,
            clickClose: true,
            autoHideDelay: 8000,
          });
          
          this._authService.logout();
        }
        return throwError(err);
      }),
      finalize(() => {
        this._loading.setLoading(false, req.url);
      })
    );
  }

}
